module.exports = __webpack_public_path__ + "static/media/loading.7255c4df.svg";